import styled from 'styled-components';

export const Wrapper = styled.div`
  & {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 20px;
  }
`;
